export const ACTION__CONVERSATIONS__ADD_CONVERSATION = 'ACTION__CONVERSATIONS__ADD_CONVERSATION';
export const ACTION__CONVERSATIONS__SET_CONVERSATION = 'ACTION__CONVERSATIONS__SET_CONVERSATION';
export const ACTION__CONVERSATIONS__UPDATE_CONVERSATION = 'ACTION__CONVERSATIONS__UPDATE_CONVERSATION';



// WEBPACK FOOTER //
// ./src/modules/conversations/actions/types.js